import { ARBITRUM, BSC, BSС_MAINNET } from "./chains";

export const MONEY_STATS_API_URL = "https://stats.gmx.io/api";
export const MEXC_API_URL = "https://chart.moneyxpro.com/api/mexc";

const BACKEND_URLS = {
  default: "https://money-server-mainnet.uw.r.appspot.com",

  // [BSС_MAINNET]: "https://gambit-server-staging.uc.r.appspot.com",
  [ARBITRUM]: "https://money-server-mainnet.uw.r.appspot.com",
  [BSC]: "https://money-ron-server.uc.r.appspot.com",
};

export function getServerBaseUrl(chainId: number) {
  if (!chainId) {
    throw new Error("chainId is not provided");
  }

  if (document.location.hostname.includes("deploy-preview")) {
    const fromLocalStorage = localStorage.getItem("SERVER_BASE_URL");
    if (fromLocalStorage) {
      return fromLocalStorage;
    }
  }

  return BACKEND_URLS[chainId] || BACKEND_URLS.default;
}

export function getServerUrl(chainId: number, path: string) {
  return `${getServerBaseUrl(chainId)}${path}`;
}
